export default __webpack_public_path__ + "static/Milan-Laser-Hair-Removal-Announces-New-Company-President-8408f47f818412e90ab4864e3aeb8e21.pdf";